import axios from 'axios';

// slices
import { setCouncil, setCurrData, setMainLoading, setModules, setRoles, setSideSubData, setStatus, setSubData, setSubModules, setUserCouncil } from '../../../app/adminSlice';

// link API
const userInfoLink = window.appConfig.restapiUrl + "/account/all_users_details/";
const userDetailsInfoLink = window.appConfig.restapiUrl + "/account/user_details_by_username/?p_username=";
const systemLogLink = window.appConfig.restapiUrl + "/account/system_logs_by_date/?p_date=";
const rolesLink = window.appConfig.restapiUrl + "/account/all_roles/";
const statusLink = window.appConfig.restapiUrl + "/account/all_statuses/";
const councilLink = window.appConfig.restapiUrl + "/account/councils_by_id/?p_council_id=null";
const councilUpdateLink = window.appConfig.restapiUrl + "/account/councils_by_id/?p_council_id="
const modulesLink = window.appConfig.restapiUrl + "/account/all_modules/";
const subModulesLink = window.appConfig.restapiUrl + "/account/all_submodules/";
const usersAccessControlLink = window.appConfig.restapiUrl + "/account/access_control_by_id/?p_user_id=";


//Users
export const getUserInfo = async (dispatch) => {
    try {
        dispatch(setMainLoading(true));

        const response = await axios.get(userInfoLink);

        if (response) {
            dispatch(setCurrData(response?.data ?? {}));
        }
        dispatch(setMainLoading(false));

    } catch (error) {
        console.error("Failed to fetch Users Info: ", error)
        dispatch(setMainLoading(false));
    }
}

//User info
export const getUserDetailsInfo = async (dispatch, username) => {
    try {
        dispatch(setMainLoading(true));
        const response = await axios.get(userDetailsInfoLink + username);

        if (response) {
            dispatch(setSideSubData(response?.data ?? {}));
        }
        dispatch(setMainLoading(false));

    } catch (error) {
        console.error("Failed to fetch user's details Info: ", error)
        dispatch(setMainLoading(false));
    }
}

//System Logs
export const getSystemLogsInfo = async (dispatch, p_date) => {
    try {
        dispatch(setMainLoading(true));
        const response = await axios.get(systemLogLink + p_date);

        if (response) {
            dispatch(setCurrData(response?.data ?? {}));
        }
        dispatch(setMainLoading(false));

    } catch (error) {
        console.error("Failed to fetch System logs Info: ", error)
        dispatch(setMainLoading(false));
    }
}

//roles & statuses & council
export const getRolesAndStatusAndCouncil = async (dispatch) => {
    try {

        dispatch(setMainLoading(true));
        const rolesResponse = await axios.get(rolesLink);
        const statusResponse = await axios.get(statusLink);
        const councilResponse = await axios.get(councilLink);

        if (rolesResponse) {
            dispatch(setRoles(rolesResponse?.data ?? {}));
        }
        if (statusResponse) {
            dispatch(setStatus(statusResponse?.data ?? {}));
        }
        if (councilResponse) {
            dispatch(setCouncil(councilResponse?.data ?? {}))
        }
        dispatch(setMainLoading(false));
    } catch (error) {
        console.error("Failed to fetch Roles ,Status and Council's Info: ", error)
        dispatch(setMainLoading(false));
    }
}
//council only for update council
export const getCouncilInfo = async (dispatch,council_id = null) => {
    try {

        dispatch(setMainLoading(true));
        const councilResponse = await axios.get(councilUpdateLink + council_id);

        if (councilResponse) {
            dispatch(setUserCouncil(councilResponse?.data ?? {}))
        }

        dispatch(setMainLoading(false));
    } catch (error) {
        console.error("Failed to fetch Council's Info: ", error)
        dispatch(setMainLoading(false));
    }
}

//modules and submodules
export const getModulesAndSubModules = async (dispatch) => {
    try {

        dispatch(setMainLoading(true));
        const modulesResponse = await axios.get(modulesLink);
        const subModulesResponse = await axios.get(subModulesLink);

        if (modulesResponse) {
            dispatch(setModules(modulesResponse?.data ?? {}));
        }
        if (subModulesResponse) {
            dispatch(setSubModules(subModulesResponse?.data ?? {}));
        }

    } catch (error) {
        console.error("Failed to fetch Modules and Submodules Info: ", error)
        dispatch(setMainLoading(false));
    }
}

//fetch access control by userid
// 0 for sideSubData which is mainly for Settings Access Control Editing, 1 is mainly for Accesses for the menu's,etc. and else is for updating both the Accesses.
export const getUsersAccessControl = async (dispatch, action, user_id) => {
    try {

        dispatch(setMainLoading(true));
        const response = await axios.get(usersAccessControlLink + user_id);

        //1 - Access control to be USED for determining user's access on the modules/submodules/edits/etc
        if (action === 1) {
            (response.status === 200) && dispatch(setSubData(response?.data ?? {}));
        
            //0 - Access control for the displayment in the Access Control submodule.
        } else if (action === 0) {
            (response.status === 200) && dispatch(setSideSubData(response?.data ?? {}));
            //other than 1 || 2 - To fetch the both of them for certain purposes
        } else {
            if (response.status === 200) {
                dispatch(setSideSubData(response?.data ?? {}));
                dispatch(setSubData(response?.data ?? {}));
            }
        }

        dispatch(setMainLoading(false));
    } catch (error) {
        console.error("Failed to fetch Modules and Submodules Info: ", error.message)
        dispatch(setMainLoading(false));
    }
}